import { sites } from '@/mocks/sites';
import SectionHeading from '@/components/base/SectionHeading';
import SiteCard from '@/components/feature/SiteCard';
import { sortSites } from '@/utils/siteUtils';

export default function HotSites() {
  const hot = sortSites(sites, 'hot').slice(0, 6);

  return (
    <section data-product-shop>
      <SectionHeading
        icon="ri-fire-line"
        title="热门网站推荐"
        subtitle="按访问热度排序的精选优质资源"
        linkTo="/category/all"
        linkLabel="更多热门"
      />
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        {hot.map((site) => (
          <SiteCard key={site.id} site={site} />
        ))}
      </div>
    </section>
  );
}